import { toast } from "$global-providers/toast-provider";
import type { PriceList } from "$routes/patient/[:patientId]/_lib/invoices/components/InvoiceCard/types";
import { defineMessage, useIntl } from "react-intl";
import LegacyPrintableInvoice from "../invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice/PrintableInvoice";
import { useFetchPrintableInvoiceRxdb } from "./use-fetch-printable-invoice-rxdb";

const ERROR_MESSAGE = defineMessage({
  id: "invoicing.getInvoice.error.msg",
  defaultMessage: "Failed to fetch this invoice",
});

type PrintableInvoiceV2Props = {
  syncInvoiceId: string;
  priceList: PriceList | null;
  payerNames: Array<string>;
  onAfterPrint: () => void;
};

export const PrintableInvoiceV2 = ({
  syncInvoiceId,
  priceList,
  payerNames,
  onAfterPrint,
}: PrintableInvoiceV2Props) => {
  const { formatMessage } = useIntl();
  const { invoice, loading } = useFetchPrintableInvoiceRxdb(
    syncInvoiceId,
    priceList,
  );

  if (loading) {
    return null;
  }

  if (!invoice) {
    toast.error(formatMessage(ERROR_MESSAGE));
    onAfterPrint();
    return null;
  }

  return (
    <LegacyPrintableInvoice
      invoice={invoice}
      invoicesToPrint={payerNames}
      onAfterPrint={onAfterPrint}
    />
  );
};
